import React, { useCallback } from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';

import {useVacantProperties} from 'src/services/api/properties/use-vacant-properties';
import {Flex, FlexColumn} from 'src/components/flex';
import Responsive from 'src/components/responsive';
import {usePersistentState} from 'src/services/storage/use-persistent-state';
import analyticsClient, { AnalyticsEvent } from 'src/services/analytics';
import Button from '@mui/material/Button';

const DISMISS_EXPIRED_DAYS = 7;

export default function VacantPropertiesAlert() {
    const data = useVacantProperties();
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const [isDismissed, setIsDismissed] = usePersistentState('vacantPropertiesAlertDismissed', false);

    const handleDismiss = useCallback(() => {
        analyticsClient.track(AnalyticsEvent.CLICKED_ON_DISMISS_VACANT_ALERT);
        setIsDismissed(true, new Date(Date.now() + DISMISS_EXPIRED_DAYS * 24 * 60 * 60 * 1000));
    }, []);

    const handleGoToProperties = useCallback(() => {
        analyticsClient.track(AnalyticsEvent.CLICIKED_ON_GO_TO_PROPERTIES_IN_VACANT_ALERT);
        navigate('/landlord/inner/properties?filter=%7B"possiblyFilled"%3Atrue%7D');
    }, []);

    if (!data?.possiblyFilledPropertiesAmount || isDismissed) {
        return null;
    }

    const isPropertiesPage = pathname.startsWith('/landlord/inner/properties');

    return <Responsive desktop>
        <Alert
            severity="warning"
            sx={{
                '& .MuiAlert-message': { width: '100%' },
                '& .MuiAlert-icon': { paddingTop: '10px' },
            }}
            onClose={handleDismiss}
        >
            <Flex width="100%" justifyContent="space-between" alignItems="center">
                <FlexColumn>
                    <Typography fontWeight="bold" color="grey.700">
                        Some vacant properties might be filled and require attention
                    </Typography>
                    <Typography variant="body2" color="inherit">
                        {data.possiblyFilledPropertiesAmount} {data.possiblyFilledPropertiesAmount === 1 ? 'property is' : 'properties are'} possibly filled. Please review and update their leasing status.
                    </Typography>
                </FlexColumn>

                <Flex>

                    {!isPropertiesPage && <Button variant="outlined" color="warning" onClick={handleGoToProperties}>
                        Go to properties
                    </Button>}
                </Flex>
            </Flex>
        </Alert>
    </Responsive>;
}
